// eslint-disable-next-line no-restricted-imports
import "./fonts.css";

import { ScopedCssBaseline } from "@mui/material";
import { ThemeProvider, type ThemeProviderProps } from "@mui/system";

import { berlinTheme } from "./theme";
/**
 * BerlinThemeProvider sets up the Berlin design system theme with proper font loading.
 *
 * Features:
 * - Loads Circular font family from local assets (WOFF2 format) - it is done via fonts.css file.
 *   It doesn't use GlobalStyles component as it strips css comments, which should include legal disclaimer for the font.
 * - Applies CssBaseline for consistent cross-browser styling
 * - Provides theme context to all child components
 *
 * Font Files:
 * - Uses CircularXXWeb-Medium.woff2 (variable font supporting multiple weights)
 * - Falls back to WOFF format for older browsers
 *
 * @see https://mui.com/material-ui/customization/theming/
 * @see https://mui.com/material-ui/react-css-baseline/
 */
export function BerlinThemeProvider(props: Omit<ThemeProviderProps, "theme">) {
  const { children } = props;

  return (
    <ThemeProvider theme={berlinTheme}>
      {/* Using ScopedCssBaseline to avoid some styles being applied globally
      Read more here: https://mui.com/material-ui/react-css-baseline/#scoping-on-children */}
      <ScopedCssBaseline>{children}</ScopedCssBaseline>
    </ThemeProvider>
  );
}
